export default class Consts {
    public static EmptyGuid: string = "00000000-0000-0000-0000-000000000000";
    public static monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
    public static PrimaryUserId: string = "12b81b57-5d35-4175-81fc-798c8c46899c";

    public static ClockTimeMetricId: string = "192a3ee4-4709-4f84-90fc-a7e20b927685";
}

